export default __webpack_public_path__ + "static/media/zh_CN.a5088c9c.svg";